import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_snackbar, {
      "model-value": _ctx.currentMessage.visible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideMessage(_ctx.currentMessage.id))),
      color: _ctx.currentMessage.type,
      class: "top-snackbar",
      rounded: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.currentMessage.message)), 1),
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            variant: "text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideMessage(_ctx.currentMessage.id))),
            class: "ml-4"
          })
        ])
      ]),
      _: 1
    }, 8, ["model-value", "color"]),
    _createVNode(_component_v_app, { id: "app" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, {
          fluid: "",
          class: "py-0 px-0 app-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }),
        _createVNode(_component_v_overlay, {
          "model-value": _ctx.isLoading,
          class: "d-flex align-center justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary"
            })
          ]),
          _: 1
        }, 8, ["model-value"])
      ]),
      _: 1
    })
  ], 64))
}